import React, { Component, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from 'components/CustomButtons/Button.js';
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { updateConfigs } from 'services/lockers/lockers';
import { QRCodeCanvas } from 'qrcode.react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";
import { uploadFile } from 'services/file';


import TextArea from '@material-ui/core/TextareaAutosize';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Divider, FormControlLabel, FormGroup, Input, TextField, Typography, Checkbox } from '@material-ui/core';
import { ArrowRightSharp, Label, ThreeSixtyOutlined } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import CardFooter from 'components/Card/CardFooter.js';
import "./style.css";

const useStyles = theme => ({
    formControl: {
        minWidth: "100%",
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    rootCircular: {
        flexGrow: 1,
        backgroundColor: "#f1f1f2"
    },
    iconView: {
        color: "white !important"
    },
    // alItems: {
    //     display: "flex",
    //     alignItems: "baseline"
    // },
    note: {
        lineHeight: '0.3em'
    }
});



const objeto = {
    data: {
        day: "Dia",
        hour: "Hora"
    },
    locker: {
        "id": "ID",
        "userId": null,
        "name": "2SP_RPR_VER",
        "status": "active",
        "qiStatus": "disconnected",
        "bateria": 100,
        "conexao": null,
        "agencyId": null,
        "appVersion": null,
        "cep": "15025-110",
        "an8": null,
        "geolocation": {
            "latitude": -20.802393627717517,
            "longitude": -49.38154625950674
        },
        "address": {
            "UF": "São José do Rio Preto - SP",
            "CEP": "15025-110",
            "Bairro": "Boa Vista",
            "Endereço": "R. Floriano Peixoto, 483"
        },
        "firmware": null,
        "createdAt": "2022-09-06T13:29:48.000Z",
        "updatedAt": "2023-06-06T19:00:18.000Z",
        "deletedAt": null,
        "group_lockers": "00000001",
        "working_hours": {
            "friday": {
                "init": "08:00",
                "final": "21:00"
            },
            "monday": {
                "init": "08:00",
                "final": "21:00"
            },
            "sunday": {
                "init": "08:00",
                "final": "21:00"
            },
            "tuesday": {
                "init": "08:00",
                "final": "21:00"
            },
            "saturday": {
                "init": "08:00",
                "final": "21:00"
            },
            "thursday": {
                "init": "08:00",
                "final": "21:00"
            },
            "weensday": {
                "init": "08:00",
                "final": "21:00"
            }
        },
        "networks": null,
        "cmd": null,
        "config": null,
        "last_connection": null,
        "qi_on": "",
        "allocation_method": "Dinâmico",
        "available_services": "Envio e Coleta",
        "expiration_hours": 72,
        "publicLockerId": "2SP_RPR_VER",
        "status_verification": "ok",
        "app_version": "CCI_3.0.201",
        "app_version_verification": "1231undefined",
        "ui_version": "2.6.0",
        "qi_version": "",
        "modelo": "0",
        "numeroSerie": "0",
        "lockerType": "0",
        "contactEmail": null,
        "mode": null,
        "typeOperation": "abun",
        "whatsapp": false,
        "ocupationRate": "61.11",
        "cond": "Ed. Versailles"
    },
    order: {
        "id": "02003dc8-9608-4545-8f33-7cb8a8238ba7",
        "lockerId": "9db325fb-4485-4576-8330-461407898307",
        "slotId": "cdeb74b5-6d00-4847-9a48-9607b4842a25",
        "carrierId": null,
        "customerId": null,
        "partnerCode": null,
        "size": "small",
        "deliveryToken": "262472",
        "collectToken": "799851",
        "addressedAt": "2023-03-13T14:56:10.000Z",
        "reservedAt": "2023-03-13T14:56:10.000Z",
        "allocatedAt": "2023-03-13T14:56:10.000Z",
        "collectedAt": null,
        "courrier_collectedAt": null,
        "expiredAt": null,
        "canceledAt": null,
        "status": "allocated",
        "paid": false,
        "smsSend": false,
        "pne": false,
        "dimensions": null,
        "receiverPhone": null,
        "condominoId": "473ab34b-d670-4596-bdf5-5d192cce68da",
        "receiverId": "0001",
        "senderId": null,
        "externalOrderId": null,
        "url": "",
        "token": "",
        "publicLockerId": "NXT_BOL_NXT",
        "publicCondominioId": "NXT_BOL_NXT",
        "receiverEmail": "0",
        "receiverCpf": "0",
        "deliveryType": "0",
        "receiverName": "0",
        "pdf": "0",
        "type": "delivery",
        "createdAt": "2023-03-13T14:56:10.000Z",
        "updatedAt": "2023-03-13T17:56:10.000Z"
    },
    condominio: {
        "id": "0158c36d-8a53-4249-9128-bec24574b4b9",
        "name": "Canopus",
        "address": "Av Tucunare 574 - Barueri",
        "idCondominio": "ENV_BAR_ENV",
        "url": null,
        "token": null,
        "agencyName": "0",
        "login": "0",
        "senha": "0",
        "contador_atual": 46,
        "contador_total": 45,
        "createdAt": "2022-12-15T20:01:35.000Z",
        "updatedAt": "2023-05-04T19:26:28.000Z"
    },
    condomino: {
        "id": "007e3914-585a-432d-8926-fc7128439f16",
        "name": "CASA 09 - EDJANE DOS SANTOS FERREIRA",
        "email": "",
        "password": "",
        "phone": "(61)98135-2152",
        "cpf": "031.379.215-11",
        "bloco": "09",
        "ap": "0",
        "ala": "",
        "createdAt": "2023-03-31T18:43:49.000Z",
        "updatedAt": "2023-06-05T17:06:44.000Z",
        "condominioId": "7f7f554d-20b1-49d0-8860-a832adead032",
        "lockerId": "b6f66677-a140-4206-b26e-3aac1365dacd",
        "app_meu_locker": false,
        "app_pwa": true,
        "n_email": false,
        "sms": true,
        "registroRaiz": true,
        "exibitionName": "CASA 09 - EDJANE DOS SANTOS FERREIRA",
        "condominoId": "50014376",
        "senha": null,
        "publicIdCondominio": "VIV_TGT_CDC",
        "publicUnidadeId": null
    },


}

const Item = ({ entity: { name, char } }) => (
    <div>{`${name}: ${char}`}</div>
);


const Loading = ({ data }) => <div>Loading</div>;

class TextAreaComplete extends Component {

    state = {
        optionsCaretStart: false,
        caretPosition: 0,
        movePopupAsYouType: false,
        minChar: 0,
        optionsCaret: "start",
        actualTokenInProvider: "",
        showSecondTextarea: false,
        renderToBody: false
    };

    _handleOptionsCaretEnd = () => {
        this.setState(() => ({
            optionsCaret: "end"
        }));
    };

    _handleOptionsCaretNext = () => {
        this.setState(() => ({
            optionsCaret: "next"
        }));
    };

    _handleOptionsCaretStart = () => {
        this.setState(() => ({
            optionsCaret: "start"
        }));
    };

    _handleShowSecondTextarea = () => {
        this.setState(({ showSecondTextarea }) => ({
            showSecondTextarea: !showSecondTextarea
        }));
    };

    _handleMovePopupAsYouType = () => {
        this.setState(({ movePopupAsYouType }) => ({
            movePopupAsYouType: !movePopupAsYouType
        }));
    };

    _handleRenderToBody = () => {
        this.setState(({ renderToBody }) => ({
            renderToBody: !renderToBody
        }));
    };

    _onChangeHandle = ({ target: { value } }) => {
        this.setState({
            text: value
        });
    };

    _changeValueTo = () => {
        this.setState({
            text: ":troph"
        });
    };

    _onCaretPositionChangeHandle = (position) => {
        this.setState({
            caretPosition: position
        });
    };

    _handleMinChar = ({ target: { value } }) => {
        this.setState({
            minChar: +value
        });
    };

    _setCaretPosition = () => {
        this.rtaRef.setCaretPosition(1);
    };

    _getCaretPosition = () => {
        alert(this.rtaRef.getCaretPosition());
    };

    _outputCaretEnd = (item, trigger) => ({
        text: item.char,
        caretPosition: "end"
    });

    _outputCaretStart = item => ({ text: item.char, caretPosition: "start" });

    _outputCaretNext = item => ({ text: item.char, caretPosition: "next" });

    _getSelectionPosition = () => {
        alert(JSON.stringify(this.rtaRef.getSelectionPosition()));
    };

    _getSelectedText = () => {
        alert(this.rtaRef.getSelectedText());
    };

    /**
     * it's the same as _outputCaretNext
     */
    _outputCaretDefault = item => item.char;

    _focus = () => {
        this.textareaRef.focus();
    };

    render() {

        const {
            optionsCaret,
            caretPosition,
            movePopupAsYouType,
            actualTokenInProvider,
            minChar,
            renderToBody
        } = this.state;

        return (
            <ReactTextareaAutocomplete
                loadingComponent={Loading}
                movePopupAsYouType={movePopupAsYouType}
                onCaretPositionChange={this._onCaretPositionChangeHandle}
                ref={(rta) => { this.rta = rta; }}
                rows="4"
                style={{
                    padding: 5,
                    width: "95%",
                }}
                containerStyle={{
                    // marginTop: 20,
                    //width: 500,
                    //height: 100,
                    // margin: "20px auto"
                }}
                className="one"
                onKeyDown={e => {
                    console.log(`pressed "${e.key}"`);
                }}
                innerRef={ref => {
                    this.textareaRef = ref;
                }}
                onItemHighlighted={info => {
                    // save highlighted item to window; use it later in E2E tests
                    window.__lastHighlightedItem = info;
                }}
                onItemSelected={info => {
                    // save selected item to window; use it later in E2E tests
                    window.__lastSelectedItem = info;
                }}
                minChar={minChar}
                onChange={this._onChangeHandle}
                renderToBody={renderToBody}
                trigger={{
                    "{": {
                        dataProvider: token => this.props.data.filter(x => x.name.includes(token)),
                        component: Item,
                        output: this._outputCaretEnd
                    },
                }}
                {...this.props}
            />
        )
    }

}

class LockerNotitication extends Component {

    state = {
        open: false,
        cmd: null,
        openSnackbar: false,
        success: "danger",
        message: "",
        configUpdate: {},
        hoursRenotification: "",
        numberRenotification: "",
        msgAllocated: "",
        msgAllocatedSubject: "",
        emailAllocated: "",
        msgReserved: "",
        msgRenotification: "",
        msgReservedSubject: "",
        msgExpirated: "",
        emailReserved: "",
        emailRenotification: "",
        msgCollected: "",
        msgCollectedSubject: "",
        emailCollected: "",
        msgRefund: "",
        msgRefundSubject: "",
        emailRefund: "",
        webhookType: "",
        hoursRenotification: 0,
        numberRenotification: 0,
        hoursExpiration: 0,
        expirationNotificate: false,
        webhookUrl: null,
        webhookToken: null,
        emailGestor: "",
        whatsappChannel: "",
        onlyWebhook: false,
        bothNotifications: false,
        qrCodeDelivery: null,
        qrCodeCollect: null,
        copied: false,
        caretPosition: 0,
        triggers: null,
        logoUrl: ""
    }

    componentDidMount() {
        const { config } = this.props;

        console.log("Notification: ", JSON.stringify(config));

        this.setState({
            msgAllocated: config.msgAllocated,
            msgAllocatedSubject: config.msgAllocatedSubject,
            emailAllocated: config.emailAllocated,
            msgReserved: config.msgReserved,
            hoursRenotification: config.hoursRenotification,
            numberRenotification: config.numberRenotification,
            msgRenotification: config.msgRenotification,
            msgReservedSubject: config.msgReservedSubject,
            emailReserved: config.emailReserved,
            emailRenotification: config.emailRenotification,
            msgCollected: config.msgCollected,
            msgCollectedSubject: config.msgCollectedSubject,
            emailCollected: config.emailCollected,
            msgRefund: config.msgRefund,
            msgRefundSubject: config.msgRefundSubject,
            emailRefund: config.emailRefund,
            webhookType: config.webhookType,
            webhookUrl: config.webhookUrl,
            webhookToken: config.webhookToken,
            emailGestor: config.emailGestor,
            whatsappChannel: config.whatsappChannel,
            onlyWebhook: config.onlyWebhook,
            bothNotifications: config.bothNotifications,
            qrCodeDelivery: config.qrCodeDelivery,
            qrCodeCollect: config.qrCodeCollect,
            hoursRenotification: config.hoursRenotification,
            numberRenotification: config.numberRenotification,
            hoursExpiration: config.hoursExpiration,
            expirationNotificate: config.expirationNotificate,
            msgExpirated: config.msgExpirated,
            logoUrl: config.logoUrl
        })

        this.copyTriggers();
    }

    handleClose = () => {
        this.setState({ open: false, openSnackbar: false });
    }

    handleOpen = () => {
        this.setState({ open: true });
    }

    handleChange = (event) => {
        const obj = event.target.id;
        console.log(event.target.id, event.target.value, parseInt(event.target.value))
        switch (obj) {
            case "msgAllocated":
                this.setState({ msgAllocated: event.target.value })
                break;
            case "msgAllocatedSubject":
                this.setState({ msgAllocatedSubject: event.target.value })
                break;
            case "emailAllocated":
                this.setState({ emailAllocated: event.target.value })
                break;
            case "msgReserved":
                this.setState({ msgReserved: event.target.value })
                break;
            case "hoursRenotification":
                this.setState({ hoursRenotification: event.target.value })
                break;
            case "numberRenotification":
                this.setState({ numberRenotification: event.target.value })
                break;
            case "msgRenotification":
                this.setState({ msgRenotification: event.target.value });
            case "msgReservedSubject":
                this.setState({ msgReservedSubject: event.target.value })
                break;
            case "emailReserved":
                this.setState({ emailReserved: event.target.value })
                break;
            case "msgCollected":
                this.setState({ msgCollected: event.target.value })
                break;
            case "msgCollectedSubject":
                this.setState({ msgCollectedSubject: event.target.value })
                break;
            case "emailCollected":
                this.setState({ emailCollected: event.target.value })
                break;
            case "msgRefund":
                this.setState({ msgRefund: event.target.value })
                break;
            case "msgRefundSubject":
                this.setState({ msgRefundSubject: event.target.value })
                break;
            case "emailRefund":
                this.setState({ emailRefund: event.target.value })
                break;
            case "webhookType":
                this.setState({ webhookType: event.target.value })
                break;
            case "webhookUrl":
                this.setState({ webhookUrl: event.target.value })
                break;
            case "webhookToken":
                this.setState({ webhookToken: event.target.value })
                break;
            case "emailGestor":
                this.setState({ emailGestor: event.target.value });
                break;
            case "whatsappChannel":
                this.setState({ whatsappChannel: event.target.value });
                break;
            case "onlyWebhook":
                this.setState({ onlyWebhook: !this.state.onlyWebhook })
                break;
            case "bothNotifications":
                this.setState({ bothNotifications: !this.state.bothNotifications })
                break;
            case "qrCodeDelivery":
                this.setState({ qrCodeDelivery: event.target.value })
                break;
            case "qrCodeCollect":
                this.setState({ qrCodeCollect: event.target.value })
                break;
            case "hoursRenotification":
                this.setState({ hoursRenotification: parseInt(event.target.value) })
                break;
            case "hoursExpiration":
                this.setState({ hoursExpiration: parseInt(event.target.value) })
                break;
            case "expirationNotificate":
                this.setState({ expirationNotificate: !this.state.expirationNotificate })
                break;
            case "logoUrl":
                this.setState({ logoUrl: event.target.value })
                break;
            case "msgExpirated":
                this.setState({ msgExpirated: event.target.value })
                break;
            case "numberRenotification":
                this.setState({ numberRenotification: parseInt(event.target.value) })
                break;
        }
    }

    handleUpdateConfig = () => {
        const configurations = {
            "msgAllocated": this.state.msgAllocated,
            "msgAllocatedSubject": this.state.msgAllocatedSubject,
            "emailAllocated": this.state.emailAllocated,
            "msgReserved": this.state.msgReserved,
            "hoursRenotification": this.state.hoursRenotification,
            "numberRenotification": this.state.numberRenotification,
            "msgRenotification": this.state.msgRenotification,
            "msgReservedSubject": this.state.msgReservedSubject,
            "emailReserved": this.state.emailReserved,
            "msgCollected": this.state.msgCollected,
            "msgCollectedSubject": this.state.msgCollectedSubject,
            "emailCollected": this.state.emailCollected,
            "msgRefund": this.state.msgRefund,
            "msgRefundSubject": this.state.msgRefundSubject,
            "emailRefund": this.state.emailRefund,
            "webhookType": this.state.webhookType,
            "webhookUrl": this.state.webhookUrl,
            "webhookToken": this.state.webhookToken,
            "emailGestor": this.state.emailGestor,
            "whatsappChannel": this.state.whatsappChannel,
            "onlyWebhook": this.state.onlyWebhook,
            "bothNotifications": this.state.bothNotifications,
            "qrCodeDelivery": this.state.qrCodeDelivery,
            "qrCodeCollect": this.state.qrCodeCollect,
            "hoursRenotification": this.state.hoursRenotification,
            "numberRenotification": this.state.numberRenotification,
            "hoursExpiration": this.state.hoursExpiration,
            "expirationNotificate": this.state.expirationNotificate,
            "msgExpirated": this.state.msgExpirated,
            "logoUrl": this.state.logoUrl
        }

        console.log(JSON.stringify(configurations));

        updateConfigs(this.props.lockerId, configurations, (resp) => {
            console.log(resp)
            if (resp) {
                this.setState({ message: 'Configurações atualizadas com sucesso!', success: 'success' });
            } else {
                this.setState({ message: 'Ops! Falha ao atualizar as configurações', success: 'danger' });
            }
            this.setState({ openSnackbar: true });
        });
    }

    CopyButtons = () => {

        let compo = [];



        for (let obj in objeto) {
            //console.log('OOOO', obj)
            const propriedade = objeto[obj];

            for (let pro in propriedade) {
                console.log(`${obj}.${pro}`)
                compo.push(<div style={{ margin: 2 }}><CopyToClipboard text={`{{${obj}.${pro}}}`}>
                    <button>{`${obj}.${pro}`}</button>
                </CopyToClipboard><span>{" "}</span></div>)
            }

            compo.push(<br />)

        }

        return compo;

    }

    handleFileChange = async (e) => {

        let files = e.target.files || e.dataTransfer.files
        if (!files.length) return


        if (files) {
            const resposta = await uploadFile(files[0]);
            this.setState({ logoUrl: encodeURI(resposta?.url) })
            console.log("=========>", JSON.stringify(resposta));
        }
    };

    copyTriggers = () => {

        let compo = [];
        var objectConstructor = ({}).constructor;

        for (let obj in objeto) {
            //console.log('OOOO', obj)
            const propriedade = objeto[obj];

            for (let pro in propriedade) {

                const level2 = propriedade[pro];

                if (level2?.constructor === objectConstructor) {
                    for (let pro2 in level2) {
                        compo.push({
                            name: `${obj} ${pro} ${pro2}`,
                            char: `{{${obj}.${pro}.${pro2}}}`
                        })
                    }

                } else {

                    compo.push({
                        name: `${obj} ${pro}`,
                        char: `{{${obj}.${pro}}}`
                    })
                }
            }
        }

        //console.log("Triggers: ", JSON.stringify(compo))

        this.setState({
            triggers: compo
        })

        return compo;

    }

    pasteMyText = async (e) => {

        /* navigator.clipboard.readText()
         .then(text => {
             console.log('Pasted content: ', text);
 
         })
         .catch(err => {
             console.error('Failed to read clipboard contents: ', err);
         });*/


        // const tt = e.target;

        // let cursorPosition = e.target.selectionStart
        // let textBeforeCursorPosition = e.target.value.substring(0, cursorPosition)
        // let textAfterCursorPosition = e.target.value.substring(cursorPosition, e.target.value.length)

        // let text = await navigator.clipboard.readText()
        // let textToInsert = ` ${text} `
        // //e.target.value = textBeforeCursorPosition + textToInsert + textAfterCursorPosition
        // tt.value = textBeforeCursorPosition + textToInsert + textAfterCursorPosition

    }









    render() {
        const { classes, lockerName, show, config, lockerId } = this.props;
        let { open, cmd, openSnackbar, success, message, configUpdate } = this.state;
        const urlChat = `http://api.whatsapp.com/send/?phone=5531984024474&text=Gostaria%20de%20me%20cadastrar%20${lockerId}&type=phone_number&app_absent=0`

        if (!show) return null;

        return (
            <div>
                <Snackbar
                    place="tc"
                    color={success}
                    icon={AddAlert}
                    message={message}
                    open={openSnackbar}
                    closeNotification={this.handleClose}
                    close
                />
                <Card>
                    <CardHeader color="primary">
                        <h4>Notificações</h4>
                        <p>Locker: {lockerName}</p>
                        <QRCodeCanvas value={urlChat} size={256} />
                        <br />
                        <strong>Chat de Cadastro:</strong><span style={{ color: 'white' }}>{" "} {urlChat}</span>
                        <br />
                        <CopyToClipboard text={urlChat}
                            onCopy={() => this.setState({ copied: true })}>
                            <button>Copiar</button>
                        </CopyToClipboard>

                        {this.state.copied ? <span style={{ color: 'white' }}>{" "} Copiado para área de transferência.</span> : null}
                        <br />

                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5, marginTop: 5 }}>Intervalo de horas para renotificação</InputLabel>
                                    <Input
                                        id="hoursRenotification"
                                        pattern="[0-9]*"
                                        value={this.state.hoursRenotification}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5, marginTop: 5 }}>Quantidade de renotificações</InputLabel>
                                    <Input
                                        id="numberRenotification"
                                        pattern="[0-9]*"
                                        value={this.state.numberRenotification}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <br></br><br></br>
                                <Divider />
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem encomenda reservada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        id="msgReserved"
                                        value={this.state.msgReserved}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Assunto encomenda reservada (email)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="msgReservedSubject"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgReservedSubject}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Email encomenda reservada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="emailReserved"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.emailReserved}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                                <br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem encomenda alocada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgAllocated}
                                        id="msgAllocated"
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem de renotificação</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgRenotification}
                                        id="msgRenotification"
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Assunto encomenda alocada (email)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="msgAllocatedSubject"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgAllocatedSubject}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Email encomenda alocada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="emailAllocated"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.emailAllocated}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>QR Code Delivery</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="qrCodeDelivery"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.qrCodeDelivery}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                                <br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem encomenda coletada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgCollected}
                                        id="msgCollected"
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Assunto encomenda coletada (email)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="msgCollectedSubject"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgCollectedSubject}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Email encomenda coletada</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="emailCollected"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.emailCollected}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>QR Code Collect</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="qrCodeCollect"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.qrCodeCollect}
                                    />

                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem devolução/refund encomenda</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgRefund}
                                        id="msgRefund"
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Assunto devolução/refund encomenda (email)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="msgRefundSubject"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgRefundSubject}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Email devolução/refund encomenda</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="emailRefund"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.emailRefund}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Mensagem de expiração</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextAreaComplete
                                        id="msgExpirated"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.msgExpirated}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Tempo para expiração (horas)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id="hoursExpiration"
                                        name="hoursExpiration"
                                        type={"number"}
                                        // disabled={role !== 'Administrador'}
                                        value={this.state.hoursExpiration}
                                        data={this.state.triggers}
                                        onChange={this.handleChange}
                                    >
                                    </TextField>
                                </FormControl>
                                <br></br><br></br>
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.expirationNotificate} onChange={this.handleChange} name="expirationNotificate" id="expirationNotificate" />}
                                    label="Notificar Expiração"
                                />
                                <br></br><br></br>
                                <Divider />
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Logo do Email</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <img
                                        src={this.state.logoUrl}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <FormControl className={classes.inputText}>
                                    <InputLabel htmlFor="url">URL</InputLabel>
                                    <Input type="file" onChange={this.handleFileChange} />
                                </FormControl>
                                <FormControl className={classes.formControl}>
                                    <Input
                                        id="logoUrl"
                                        onChange={this.handleChange}
                                        onDoubleClick={this.pasteMyText}
                                        data={this.state.triggers}
                                        value={this.state.logoUrl}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Número de Notificações</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id="numberRenotification"
                                        name="numberRenotification"
                                        type={"number"}
                                        // disabled={role !== 'Administrador'}
                                        value={this.state.numberRenotification}
                                        data={this.state.triggers}
                                        onChange={this.handleChange}
                                    >
                                    </TextField>
                                </FormControl>
                                <br></br><br></br>
                                <InputLabel style={{ marginBottom: 5 }}>Tempo entre as notificações (horas)</InputLabel>
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id="hoursRenotification"
                                        name="hoursRenotification"
                                        type={"number"}
                                        // disabled={role !== 'Administrador'}
                                        value={this.state.hoursRenotification}
                                        data={this.state.triggers}
                                        onChange={this.handleChange}
                                    >
                                    </TextField>
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                            </GridItem>



                            <GridItem xs={12} sm={12} md={6}>
                                <br></br>
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.onlyWebhook} onChange={this.handleChange} name="onlyWebhook" id="onlyWebhook" />}
                                    label="Somente Webhook"
                                />
                                <br></br>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                <br></br>
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.bothNotifications} onChange={this.handleChange} name="bothNotifications" id="bothNotifications" />}
                                    label="Ambas Notificações (Webhook + WhatsApp + E-mail)"
                                />
                                <br></br>
                            </GridItem>
                            <br></br><br></br><br></br>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5 }}>Webhook Type</InputLabel>
                                    <Input
                                        id="webhookType"
                                        value={this.state.webhookType}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5 }}>Webhook URL</InputLabel>
                                    <Input
                                        id="webhookUrl"
                                        value={this.state.webhookUrl}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5 }}>Webhook Token</InputLabel>
                                    <Input
                                        id="webhookToken"
                                        value={this.state.webhookToken}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5 }}>E-mail Gestor</InputLabel>
                                    <Input
                                        id="emailGestor"
                                        value={this.state.emailGestor}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <FormControl className={classes.formControl}>
                                    <InputLabel style={{ marginBottom: 5 }}>WhatsApp Channel</InputLabel>
                                    <Input
                                        id="whatsappChannel"
                                        value={this.state.whatsappChannel}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <br></br><br></br>
                                <Divider />
                            </GridItem>









                            <GridItem xs={12} sm={12} md={6}>
                                <br></br><br></br>
                                <Button onClick={this.handleUpdateConfig} color="primary" autoFocus>
                                    Salvar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                    {/* <CardBody>
                        <GridContainer>
                            {this.CopyButtons()}
                        </GridContainer>
                    </CardBody> */}
                </Card>
            </div>
        );
    }
}

export default withStyles(useStyles)(LockerNotitication);